import { Observable } from 'rxjs';
import { ReservationPreChekin } from '../../reservation/models/reservation-response';

export abstract class PrecheckinStep1Repository {
    abstract savePrecheckin(
        reservation: ReservationPreChekin,
    ): Observable<boolean>;
    abstract clearPrecheckin(): Observable<boolean>;
    abstract updatePrecheckin(data: any): Observable<boolean>;
    abstract getPrecheckin(): Observable<any>;
    abstract sendChangeHour(newDate: string): Observable<any>;
}
